import { render, staticRenderFns } from "./prodotti.vue?vue&type=template&id=18ba3b3f&"
import script from "./prodotti.vue?vue&type=script&lang=js&"
export * from "./prodotti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports